/**
 * Application Version
 *
 * Increment this version number with each deployment to verify
 * that the hosted app matches the development environment.
 *
 * Format: MAJOR.MINOR.PATCH
 * - MAJOR: Breaking changes or major feature releases
 * - MINOR: New features, non-breaking changes
 * - PATCH: Bug fixes, small improvements
 */

export { APP_VERSION } from '../version';

/**
 * Build date helper. Computed at runtime so it always reflects when the bundle was executed.
 * Override via environment variable if a fixed value is needed.
 */
const fallbackDate = new Date().toISOString().slice(0, 10);

const viteBuildDate =
  typeof import.meta !== 'undefined' &&
  (import.meta as any).env &&
  (import.meta as any).env.VITE_BUILD_DATE;

const nodeBuildDate =
  typeof process !== 'undefined' &&
  typeof process.env !== 'undefined' &&
  process.env.BUILD_DATE;

export const BUILD_DATE = viteBuildDate || nodeBuildDate || fallbackDate;

/**
 * Optional label to display alongside the semantic version.
 * Update as needed for marketing-friendly release names.
 */
export const VERSION_NAME = 'Product Radar';

